// extracted by mini-css-extract-plugin
export default {"rootDirection":"jk5WNT","root":"ZZ6eh7","active":"_4J95Tz","isMaxContent":"y0ZLPJ","isWrapText":"s8GR0i","label":"xc2xuF","link":"fsFmUR","icon":"vWlb1f"};